<template>
    <div class="digital-classrooms-update-banner-container">
        <div class="digital-classrooms-update-banner -wrap">
            <div class="digital-classrooms-update-banner__left-container">
                <h2 class="digital-classrooms-update-banner__title" v-html="$t('LiveEventsNotify.title')"></h2>
                <p class="digital-classrooms-update-banner__description" v-html="$t('LiveEventsNotify.description')"></p>
            </div>
            <div class="digital-classrooms-update-banner__right-container">
                <div class="digital-classrooms-update-banner__portraits">
                    <img v-for="(image, index) in trainerImages" :key="index" :src="getImagePath(image)" alt="" class="digital-classrooms-update-banner__circular-portrait"/>
                </div>
                <div class="digital-classrooms-update-banner__buttons">
                    <TotemButton 
                        @click="$router.push({name:'all-packages-virtual-classrooms'})" 
                        class="digital-classrooms-update-banner__register-button" 
                        color="secondary"
                        :label="$t('LiveEventsNotify.button')"
                    />
                    <span class="icon-cancel digital-classrooms-update-banner__close-button" @click="closeBanner"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import importAllImages from 'components/shared/mixins/importAllImages'
    export default {
        name: 'digital-classrooms-update-banner',
        data () {
            return {
                trainerImages: []
            }
        },
        mixins: [importAllImages],
        methods: {
            closeBanner () {
                window.localStorage.setItem('showLiveEventsNotifyBanner', false)
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            },
            getImagePath (image) {
                return require(`@/assets/images/livenotifybanner/${image}`)
            },
            getIndex (index) {
                return +index
            }
        },
        created () {
            this.trainerImages = this.importAll(require.context('@/assets/images/livenotifybanner/', false, /\.(png|jpe?g|svg)$/))
        }
    }
</script>

<style lang="scss" scoped>
    .digital-classrooms-update-banner-container {
        margin: 30px 0px 0px 0px;
    }
    .digital-classrooms-update-banner {
        background: $champagne;
        color: $black;
        border-radius: 10px;
        padding: 20px 30px;
        display: flex;

        [class*="mobile"] &, [class*="desktop_l"] & {
            flex-direction: column;
        }

        &__title {
            font-family: 'Quicksand-Bold';

            [class*="mobile"] &, [class*="desktop_l"] & {
                font-size: 2.1rem;
            }
        }

        &__description {
            margin: 20px 0px 0px;
            font-family: 'Nunito-Regular';
            line-height: 24px;
            font-size: 1.7rem;

            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 20px 0px 20px;
            }
        }

        &__right-container {
            flex-direction: row;
            display: flex;
            align-items: center;
            justify-content: center;

            [class*="mobile"] & {
                flex-direction: column;
            }
        }

        &__circular-portrait {
            margin: 0 5px;

            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 0 3px;
            }
        }

        &__left-container {
            flex-direction: column;
            display: flex;
            flex: 1;
            justify-content: center;
        }

        &__buttons {
            padding: 10px;
            margin: 0 0 0 15px;
            display: flex;
            align-items: center;
            line-height: 1;
            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 15px 0px 0px 15px;
            }
        }

        &__close-button {
            font-size: 3rem;
            margin: 0 20px;
        }
    }
</style>
